import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import SectionOne from './Components/SectionOne';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Aboutus from './Components/Aboutus';
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsConditions from './Components/TermsConditions';
import RefundPolicy from './Components/RefundPolicy';
import GrievancePolicy from './Components/GrievancePolicy';
import Contactus from './Components/Contactus';

export default function App() {

  const AppContent = () => {
    return (
      <>
        <Routes>
          <Route exact path="/" element={<SectionOne />} />
          <Route exact path="/about" element={<Aboutus />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/terms-conditions" element={<TermsConditions />} />
          <Route exact path="/refund-policy" element={<RefundPolicy />} />
          <Route exact path="/grievance-policy" element={<GrievancePolicy />} />
          <Route exact path="/contact-us" element={<Contactus />} />
        </Routes>

      </>
    );
  }

  return (

    <Router>
      <AppContent />
    </Router>



  )
}
